import React from 'react'
import ReactDOM, {unmountComponentAtNode} from 'react-dom'
import {DataObjectId} from 'yougile-model'
import {UIElement} from '../ui-element'

export class ReactRenderContainer extends UIElement {
  private Component: React.ComponentType
  private currentElement: HTMLElement
  constructor(companyId: DataObjectId, component: React.ComponentType) {
    super(companyId, undefined, undefined)
    this.Component = component
    this.onUnmount = () => {
      this.unmountComponentAtNode()
    }
    this.isDrivenByReact = true
  }

  public override render(el: HTMLElement): void {
    super.render(el)
    if (el !== this.currentElement) {
      this.unmountComponentAtNode()
    }
    this.currentElement = el
    ReactDOM.render(
      <>
        <this.Component />
      </>,
      el
    )
  }

  public unmountComponentAtNode() {
    this.currentElement && unmountComponentAtNode(this.currentElement)
  }
}
